import mixpanel, { type Dict, type OverridedMixpanel } from 'mixpanel-browser'

import { __DEV__, __STAGING__ } from '../infra/environment'
import { getAnalyticsUserForMixpanel } from './getAnalyticsUser'

type MixpanelWithShipperGuideProperty = {
  shipper_guide?: OverridedMixpanel
} & typeof mixpanel

const mixpanelWithShipperGuideProperty = mixpanel as MixpanelWithShipperGuideProperty

export const analytics = {
  init() {
    if (!this.isMixpanelEnabled()) return false

    if (mixpanelWithShipperGuideProperty.shipper_guide) return false

    mixpanel.init(
      process.env.REACT_APP_SHIPPER_GUIDE_MIXPANEL_TOKEN!,
      {
        record_sessions_percent: 10,
      },
      'shipper_guide'
    )
  },

  track(label: string, obj?: Dict) {
    if (!this.isMixpanelEnabled()) return false

    const shipperGuideMixpanel = mixpanelWithShipperGuideProperty.shipper_guide

    if (this.isProjectInitialized() && typeof shipperGuideMixpanel?.track !== 'undefined') {
      shipperGuideMixpanel.track(label, obj)

      if (__DEV__ || __STAGING__) {
        console.info('SHIPPER GUIDE MIXPANEL EVENT:', label, obj || '')
      }
    }
  },

  setup() {
    const shipperGuideUser = getAnalyticsUserForMixpanel()
    if (this.isProjectInitialized() && shipperGuideUser) {
      const { id, email, name, company, type, roles, shipper_test, user_category, business_type } =
        shipperGuideUser
      mixpanelWithShipperGuideProperty.shipper_guide!.register(shipperGuideUser)
      mixpanelWithShipperGuideProperty.shipper_guide!.identify(shipperGuideUser.email)
      mixpanelWithShipperGuideProperty.shipper_guide!.people.set({
        id,
        $email: email,
        $name: name,
        company,
        roles,
        type,
        shipper_test,
        user_category,
        business_type,
      })
    }
  },

  isMixpanelEnabled() {
    return typeof mixpanel !== 'undefined'
  },

  isProjectInitialized() {
    return typeof mixpanelWithShipperGuideProperty.shipper_guide !== 'undefined'
  },
}
